import gtag_event from './gtag-init';
import {otp_init, check_otp_session} from '../../global/otp';
import {whatsapp_validation_form, get_enquiry_count, increment_enquiry_count, should_require_otp, clean_phone_number} from '../../global/validation-form';
import {insert_leads_to_db} from '../../global/leads-submission';

jQuery(function ($) {

  var current_form_class = '.faq-cta-form',
      btn_submit = '#faq-cta-submit',
      name_field = $('.faq-cta-form [name="name"]'),
      number_field = $('.faq-cta-form [name="whatsapp_number"]'),
      alert_field = $('.faq-cta-form .message-failed'),
      process_submit = false;

  $('#faq-form-modal').on('shown.bs.modal', function () {
    gtag_event('Faq click action', 'CTA_FAQ');
  });


  $(document).on('click', '.btn-faq-lead', function () {
    // Refresh the nonce (non-blocking)
    // eslint-disable-next-line no-undef
    $.post(global_params.ajax_url, { action: 'refresh_whatsapp_nonce' }, function(response) {
      if (response.success) {
        $('input[name="_wpnonce"]').val(response.data.nonce);
        console.info('refresh_whatsapp_nonce success', response.data.nonce);
      }
    });

    if(check_otp_session('on_timer') == false) {
      $('#faq-form-modal').modal('show');
    }
  });

  /**
   * Check any required field to change the button state
   */
  function check_vt_form_field() {

    var disable_form = false;

    $('.faq-cta-form').find('.form-required').each(function(i, el){

      if ( '' === $(el).val() ) {
        disable_form = true;
      }
    });

    if( disable_form ) {
      $('#faq-cta-submit').attr('disabled', true);
    } else {
      $('#faq-cta-submit').attr('disabled', false);
    }
  }

  check_vt_form_field();

  $('.form-required').on('change', function(){
    check_vt_form_field();
  });

  function submit_whatsapp_form(data) {

    if (data == -1 || data == '') {
      alert_field.text('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.').show();
      return;
    }

    if(data.success) {
      // submit success
      $(current_form_class + ' [name=submit_status]').val('1').trigger('change');

      // send GA tracking
      gtag_event('Whatsapp Submission', 'Faq');

      document.cookie = 'faq_submitted='+true;
      $('.accordion-faq div').removeClass('masked collapsed');
      $('.btn-faq-lead').hide();
      $('#faq-form-modal').modal('hide');
    } else {
      $(current_form_class + ' .message-success').hide();
      $(current_form_class + ' .message-failed').html('<p>' + data.data.message + '</p>').show();
    }
  }

  $('.faq-cta-form').on('submit', function(e){

    e.preventDefault();

    let leads_name = name_field.val();
    let leads_number = number_field.val();
    let leads_form = {
      'name': leads_name,
      'number': leads_number,
      'number_field': number_field,
      'alert_field': alert_field,
    };

    if (whatsapp_validation_form(leads_form) == false) {
      gtag_event('Leads form button clicked', 'Faq-not-validated');
      return false;
    }

    // Track enquiry count and conditionally require OTP every 3rd enquiry
    const cleanedNumber = clean_phone_number(leads_number);
    const nextEnquiryCount = get_enquiry_count(cleanedNumber) + 1;
    
    // Only call OTP on 1st, 3rd, 6th, 9th... enquiries
    if (should_require_otp(nextEnquiryCount)) {
      console.info('Enquiry count for ' + cleanedNumber + ': ' + nextEnquiryCount + '. OTP validation required.');
      if (otp_init(current_form_class, e, leads_number, btn_submit) === false) {
        return false;
      }
    }

    if (true === process_submit) {
      alert('Mohon ditunggu, data anda sedang diproses');
      return;
    }

    // Increment enquiry count after submission
    const newCount = increment_enquiry_count(cleanedNumber);
    
    // Clear otp_validated cookie if next enquiry will require OTP validation
    const nextEnquiry = newCount + 1;
    if (should_require_otp(nextEnquiry)) {
      document.cookie = 'otp_validated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }

    gtag_event('Leads form button clicked', 'Faq-validated');

    let data_form = $(this).serialize() + '&current_url=' + $(location).attr('href');

    // insert leads data to DB
    insert_leads_to_db($(this));

    $.ajax({
      type: $(this).attr('method'),
      url: $(this).attr('action'),
      data: data_form,
      beforeSend: function () {
        $(current_form_class + ' .message-text').hide();
        $(current_form_class + ' .message-success').hide();
        $(current_form_class + ' .message-failed').hide();
        $(current_form_class + ' .loader').show();
        $(current_form_class + ' .message-failed').hide();
        $('#faq-form-modal div.content-modal').hide();
        $('#faq-form-modal div.loading-state-modal').show();
        $(btn_submit).prop('disabled', true);
        process_submit = true;
      },
      success: function (data) {
        if(!data.success) {
          $('#faq-form-modal div.content-modal').show();
          $('#faq-form-modal div.loading-state-modal').hide();
        }
        $(current_form_class + ' .loader').hide();
        $(current_form_class + ' .message-success').hide();
        submit_whatsapp_form(data);
        $(btn_submit).prop('disabled', false);
        process_submit = false;
      },
      error: function (data) {
        $('#faq-form-modal div.content-modal').show();
        $('#faq-form-modal div.loading-state-modal').hide();
        console.log('An error occurred.');
        console.log(data);
        $(btn_submit).prop('disabled', false);
        process_submit = true;
      },
    });
  });

});


// WEBPACK FOOTER //
// ./scripts/page-template/template-aimm/faq-submission.js